import { apiClient, type Paginated } from '@/core/api';
import type { IcpSegment, IcpSegmentInput } from './types';

export const BASE = '/crm/icp-segments/';

export interface IcpSegmentListParams {
  /** `true` → only archived rows. Unset → live only. */
  archived?: boolean;
  page_size?: number;
}

export async function listIcpSegments(
  params: IcpSegmentListParams = {},
): Promise<Paginated<IcpSegment>> {
  const { data } = await apiClient.get<Paginated<IcpSegment>>(BASE, { params });
  return data;
}

export async function createIcpSegment(input: IcpSegmentInput): Promise<IcpSegment> {
  const { data } = await apiClient.post<IcpSegment>(BASE, input);
  return data;
}

export async function updateIcpSegment(
  id: number,
  input: Partial<IcpSegmentInput>,
): Promise<IcpSegment> {
  const { data } = await apiClient.patch<IcpSegment>(`${BASE}${id}/`, input);
  return data;
}

/** Archive — leads keep the segment; it can't be newly picked. */
export async function archiveIcpSegment(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

export async function restoreIcpSegment(id: number): Promise<IcpSegment> {
  const { data } = await apiClient.post<IcpSegment>(`${BASE}${id}/restore/`);
  return data;
}
